module.exports = __webpack_public_path__ + "img/rating-star-void.bdb3bce7.svg";